/* eslint-disable no-console */
import { updateAssetUrlDimensions } from '../widen-utils';

let previewData = {};

const getLargeImageUrl = src => (
  updateAssetUrlDimensions({
    src,
    width: 750, // 660
    height: 420, // 372,
  })
);

const getPreviewData = () => (
  previewData
);

const setPreviewData = (data) => {
  const { alt, caption, src, type, videosrc } = data;
  previewData = {
    alt,
    caption,
    src,
    type,
    videosrc,
  };
};

const update = (options) => {
  const { item } = options;
  const img = item.querySelector('img');
  setPreviewData({
    alt: img.alt,
    caption: item.getAttribute('data-caption'),
    src: getLargeImageUrl(img.src),
    type: 'image',
  });
};

export {
  getPreviewData,
  update,
};
/* eslint-enable no-console */
